module.exports = __webpack_public_path__ + "a0f5e0b8c6193f5d6e84931b9b25f49a.webp";